import React from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import MobileWidgetSettingsModal from "./MobileWidgetSettingsModal";

const MobileWidget = ({ value, role }) => {
   return (
      <Widget
         styleName="mobile-widget"
         bgColor={value.backgroundColourHex}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetId={value.id}
                  widgetName={value.name}
                  icon="setting"
                  deleteIcon="true"
                  children={<MobileWidgetSettingsModal value={value} />}
               />
            )
         }
      >
         Mobile Widget
      </Widget>
   );
};

export default MobileWidget;
